import { CommonModule } from "@angular/common";
import { Component, ElementRef, inject, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { MatRadioChange, MatRadioModule } from "@angular/material/radio";
import { Router } from '@angular/router';
import { TripRequestType } from "../../dashboard/models/trip-request-models";
import { TripRequestService } from "../../dashboard/services/trip-request.service";
import { LayoutService } from "../../shared/services/layout.service";
import { SelectedProfileService } from "../../shared/services/selected-profile.service";

@Component({
  selector: 'app-trip-request-type',
  standalone: true,
  imports: [
    CommonModule,
    MatRadioModule,
    MatDialogModule,
    MatIcon
  ],
  templateUrl: './trip-request-type.component.html',
  styleUrl: './trip-request-type.component.scss',
})

export class TripRequestTypeComponent implements OnInit {
  private router = inject(Router);
  private tripRequestService = inject(TripRequestService);
  private selectedProfileService = inject(SelectedProfileService);
  @ViewChild('confirmationDialogTemplate', { static: true }) confirmationDialogTemplate!: TemplateRef<any>;
  tripRequestType = '';  
  preTripFlag = false;
  private el = inject(ElementRef);
  private dialogRef?: MatDialogRef<any>;
  private dialog = inject(MatDialog);
  isMobileView = inject(LayoutService).isMobile;
  displayPreTripText = false;

  ngOnInit(): void {
    this.tripRequestService.getPreTripFlag(this.selectedProfileService.selectedRecipientId()!)
        .subscribe(data => {
          this.preTripFlag = data;     
        });
  }

  onSelectionChange($event: MatRadioChange<string>) {
    this.tripRequestType = $event.value;
  }

  goToTripRequest() {
     if (this.tripRequestType !== '') {
      if (!this.preTripFlag && this.tripRequestType === TripRequestType.Pre) {
        this.openDialog();
      } 
      else {
          this.router.navigate(['/trip-request', this.tripRequestType.toLowerCase()]);  
      }
    }
  }

  openDialog() {
    const rect = this.el.nativeElement.getBoundingClientRect();
    const config = new MatDialogConfig();
    config.width = this.isMobileView() ? '80%' : '40%';
    config.disableClose = true;
    if (!this.isMobileView()) {
      config.panelClass = 'trip-request-confirmation-dialog';
      config.position = {
        left: `${rect.left + rect.width / 2}px`,
      };
    }
    this.dialogRef = this.dialog.open(this.confirmationDialogTemplate, config);
    this.dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.router.navigate(['/trip-request', this.tripRequestType.toLowerCase()]);  
      }
    });
  }
  
  showPreTripText() {
    this.displayPreTripText = !this.displayPreTripText;
  }

    
}